module.exports = __webpack_public_path__ + "img/galeria-desportiva-3.466dc79b.jpg";